import { render, staticRenderFns } from "./customModal.vue?vue&type=template&id=dd0e6fc4&scoped=true"
import script from "./customModal.vue?vue&type=script&lang=js"
export * from "./customModal.vue?vue&type=script&lang=js"
import style0 from "./customModal.vue?vue&type=style&index=0&id=dd0e6fc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd0e6fc4",
  null
  
)

export default component.exports